import { render } from "./PartnerAvant.vue?vue&type=template&id=353b7b46"
import script from "./PartnerAvant.vue?vue&type=script&lang=js"
export * from "./PartnerAvant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__